import { Directive, Input } from "@angular/core";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzCellEllipsisDirective } from "ng-zorro-antd/table";

@Directive({
  selector: "th[uiEllipsis],td[uiEllipsis]",
  host: {
    "[class.ant-table-cell-ellipsis]": "nzEllipsis",
  },
})
export class UiCellEllipsisDirective extends NzCellEllipsisDirective {
  @Input("uiEllipsis") @InputBoolean() public nzEllipsis = true;
}
